import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    selectWrapper: {
        display: "flex",
        flexDirection: "column",
    },
    label: {
        fontSize: 12,
        fontWeight: 700,
        color: theme.palette.primary.dark,
        textTransform: "uppercase",
        marginBottom: theme.spacing(1.5),
    },
    select: {
        height: theme.spacing(10.25),
        backgroundColor: theme.palette.primary.main,
        "& fieldset": {
            borderColor: theme.palette.border.select,
        },
        "& .MuiSelect-select": {
            textOverflow: "ellipsis",
            overflow: "hidden",
            whiteSpace: "nowrap",
            "&.MuiInputBase-input": {
                alignItems: "self-start",
            },
            fontSize: 14,
            fontWeight: 400,
            color: theme.palette.primary.darker,
            fontFamily: "Open Sans",
            padding: `${theme.spacing(2.25)} ${theme.spacing(3)}`,
        },
    },
    selectSingle: {
        "& .MuiSelect-select": {
            display: "flex !important",
        },
    },
    selectMultiple: {
        "& .MuiSelect-select": {
            display: "inline-block !important",
        },
    },
    menuItem: {
        display: "flex",
        alignItems: "center",
        marginBottom: theme.spacing(1),
        fontSize: `14px !important`,
        "&.Mui-selected": {
            backgroundColor: `${theme.palette.secondary.main} !important`,
        },
    },
    smallSelect: {
        "& .MuiSelect-select": {
            padding: "2px 12px !important",
            fontSize: 12,
        },
    },
    smallLabel: {
        fontSize: 10,
        fontWeight: 700,
        color: theme.palette.primary.dark,
        textTransform: "uppercase",
        marginBottom: theme.spacing(1.5),
    },
    menuItemWithIcon: {
        "& > span": {
            display: "flex",
            alignItems: "center",
            gap: theme.spacing(2),
        },
    },
    searchBarClassName: {
        width: `100% !important`,
    },
    avatar: {
        width: `${theme.spacing(6)} !important`,
        height: `${theme.spacing(6)} !important`,
        marginRight: theme.spacing(1),
    },
    renderValueWrapper: {
        display: "flex",
        alignItems: "center",
    },
    selectedItemsJoined: {
        flex: "1 1 auto",
        textOverflow: "ellipsis",
        overflow: "hidden",
        whiteSpace: "nowrap",
        display: "inline-block !important",
    },
    counterBox: {
        flex: "0 0 auto",
        width: theme.spacing(5.5),
        height: theme.spacing(5.5),
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.info.main,
        borderRadius: "50%",
        fontSize: 12,
        fontWeight: 700,
        fontFamily: "Open Sans",
    },
    fullWidth: {
        width: "100%",
        "& .MuiSelect-select": {
            maxWidth: "initial",
        },
    },
    singleSelectRenderValue: {
        display: "flex",
        alignItems: "center",
        width: "100%",
    },
    menuItemWithTag: {
        "& > span": {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
        },
    },
    menuItemTag: {
        marginLeft: theme.spacing(1),
    },
}));

export const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: "300px",
        },
    },
};
